export default class AppClientDbMapping {
  public static setupMappings(): void {
    console.log('+++ static AppClientDbMapping.setupMappings');

    // ! IMPORTANT
    // ! WHEN YOU ADD SOMETHING HERE, PUT IT IN entry.php TOO!

    CrowdHub_App.BUCKET_BLURB = 'Blurb';
    CrowdHub_App.BUCKET_MEDIA = 'Media';
    CrowdHub_App.BUCKET_RESOURCES = 'Resources';
    CrowdHub_App.BUCKET_SPEAKER = 'Speaker';
    CrowdHub_App.BUCKET_PARTNER = 'Partner';
    CrowdHub_App.BUCKET_LEADERBOARD = 'Leaderboard';
    CrowdHub_App.BUCKET_ADS = 'Ad';
    CrowdHub_App.BUCKET_LIBRARY = 'Library';
    CrowdHub_App.BUCKET_LESSON = 'Lesson';
    CrowdHub_App.BUCKET_TRACK = 'Track';
    CrowdHub_App.BUCKET_OTSESSION = 'OTSession';
    CrowdHub_App.BUCKET_GROUPOTSESSION = 'GroupOTSession';
    CrowdHub_App.BUCKET_BREAKOUTOTSESSION = 'BreakoutOTSession';
    CrowdHub_App.BUCKET_IRLSESSION = 'IRLSession';
    CrowdHub_App.BUCKET_COHORT = 'Cohort';
    CrowdHub_App.BUCKET_PRODUCT = 'Product';
    CrowdHub_App.BUCKET_COMMUNITY = 'Community';
    CrowdHub_App.BUCKET_FORUMTOPIC = 'ForumTopic';
    CrowdHub_App.BUCKET_FORUMPOST = 'ForumPost';

    CrowdHub_App.BUCKET_ID_LESSON = 11;
    CrowdHub_App.BUCKET_ID_TRACK = 10;
    CrowdHub_App.BUCKET_ID_AD = 13;
    CrowdHub_App.BUCKET_ID_LEADERBOARD = 14;
    CrowdHub_App.BUCKET_ID_OTSESSION = 1;
    CrowdHub_App.BUCKET_ID_PARTNER = 8;
    CrowdHub_App.BUCKET_ID_GROUPOTSESSION = 12;
    CrowdHub_App.BUCKET_ID_COHORT = 15;
    CrowdHub_App.BUCKET_ID_PRODUCT = 20;
    CrowdHub_App.BUCKET_ID_BREAKOUTOTSESSION = 21;
    CrowdHub_App.BUCKET_ID_IRLSESSION = 22;
    CrowdHub_App.BUCKET_ID_COMMUNITY = 23;
    CrowdHub_App.BUCKET_ID_FORUMTOPIC = 24;
    CrowdHub_App.BUCKET_ID_FORUMPOST = 25;

    CrowdHub_App.ACTION_COMPLETE = 1;
    CrowdHub_App.ACTION_FAVORITE = 2;
    CrowdHub_App.ACTION_REVIEW = 11;
    CrowdHub_App.ACTION_ATTEND = 12;
    CrowdHub_App.ACTION_JOINED = 13;
    CrowdHub_App.ACTION_START = 14;
    CrowdHub_App.ACTION_FINISH = 15;
    CrowdHub_App.ACTION_SHARE = 16;
    CrowdHub_App.ACTION_COMMENT = 17;
    CrowdHub_App.ACTION_CREATE = 18;
    CrowdHub_App.ACTION_DOWNLOAD = 19;
    CrowdHub_App.ACTION_COMMIT = 20;
    CrowdHub_App.ACTION_COMPLETECOMMITMENT = 21;
    CrowdHub_App.ACTION_QA = 22;
    CrowdHub_App.ACTION_POLL = 23;
    CrowdHub_App.ACTION_LIVECHAT = 24;
    CrowdHub_App.ACTION_EMOJI = 25;
    CrowdHub_App.ACTION_RAISEHAND = 26;
    CrowdHub_App.ACTION_VOTING = 27;
    CrowdHub_App.ACTION_ANONYMOUS_QUESTION = 29;
    CrowdHub_App.ACTION_MODERATE_QA = 30;
    CrowdHub_App.ACTION_VISITOR_AWARENESS = 31;
    //WHEN YOU ADD SOMETHING HERE, PUT IT IN entry.php TOO!

    CrowdHub_App.TAGTYPE_ADMIN = 1;
    CrowdHub_App.TAGTYPE_SESSION = 2;
    CrowdHub_App.TAGTYPE_CATEGORY = 3;
    CrowdHub_App.TAGTYPE_TITLE = 4;
    CrowdHub_App.TAGTYPE_INTEREST = 5;
    CrowdHub_App.TAGTYPE_SWITCHPREFS = 8;
    CrowdHub_App.TAGTYPE_LIVEEVENT = 9;
    CrowdHub_App.TAGTYPE_NAVIGATION = 10;
    CrowdHub_App.TAGTYPE_STREAMTYPE = 11;
    CrowdHub_App.TAG_TYPE_ARCHIVE_MODE = 12;
    CrowdHub_App.TAGTYPE_LIVESESSIONLAYOUT = 20;
    CrowdHub_App.TAGTYPE_LIVESESSION_CONTENTHINT = 21;
    CrowdHub_App.TAGTYPE_POINTMULTIPLIER = 99;
    CrowdHub_App.TAGTYPE_DONOTPREVIEW = 166;
    CrowdHub_App.TAGTYPE_PROFILEICON = 200;
    CrowdHub_App.TAGTYPE_ACCESSLEVEL = 300;

    CrowdHub_App.TAGTYPE_NAMES = [];
    CrowdHub_App.TAGTYPE_NAMES[1] = 'Admin';
    CrowdHub_App.TAGTYPE_NAMES[2] = 'Session';
    CrowdHub_App.TAGTYPE_NAMES[3] = 'Category';
    CrowdHub_App.TAGTYPE_NAMES[4] = 'Title';
    CrowdHub_App.TAGTYPE_NAMES[5] = 'Interest';
    CrowdHub_App.TAGTYPE_NAMES[8] = 'Switch Preferences';
    CrowdHub_App.TAGTYPE_NAMES[9] = 'Live Event';
    CrowdHub_App.TAGTYPE_NAMES[10] = 'Navigation';
    CrowdHub_App.TAGTYPE_NAMES[11] = 'Stream Type';
    CrowdHub_App.TAGTYPE_NAMES[20] = 'Live Session Layout';
    CrowdHub_App.TAGTYPE_NAMES[21] = 'Live Session Content Hint';
    CrowdHub_App.TAGTYPE_NAMES[99] = 'Point Multiplier';
    CrowdHub_App.TAGTYPE_NAMES[200] = 'Profile Icon';
    CrowdHub_App.TAGTYPE_NAMES[300] = 'Access Level';
    CrowdHub_App.TAGTYPENAME_ARCHIVE_MODE = 'Archive Mode';
    CrowdHub_App.TAGTYPENAME_FORUM = 'Forum';

    CrowdHub_App.TAGGROUP_COMPLETE_PREFS = 1;
    CrowdHub_App.TAGGROUP_COMPLETE_SWITCHES = 2;

    CrowdHub_App.TAGID_MAINEVENT = 1;
    CrowdHub_App.TAGID_BREAKOUT = 2;
    CrowdHub_App.TAGID_PANEL = 3;
    CrowdHub_App.TAGID_FEATURED = 4;
    CrowdHub_App.TAGID_ALLOWCONTACTS = 17;
    CrowdHub_App.TAGID_LIVESESSION_CONTENTHINT = 21;
    CrowdHub_App.TAG_NAVIGATION_EXTERNAL = 22;
    CrowdHub_App.TAG_RECORDED_YOUTUBE = 29;
    CrowdHub_App.TAG_RECORDED_BRIGHTCOVE = 121;
    CrowdHub_App.TAG_ARCHIVE_MODE_OFF = 32;
    CrowdHub_App.TAG_RECORDED_FACEBOOK = 49;

    CrowdHub_App.TAGNAME_ALWAYS = 'Always';
    CrowdHub_App.TAGNAME_OPENTOK_BROADCAST = 'Opentok Broadcast';
    CrowdHub_App.TAGNAME_HIDEATTENDEES = 'Hide Attendees';
    CrowdHub_App.TAGNAME_STOPSNAPTOLIVE = 'Stop Snap To Live';
    CrowdHub_App.TAGNAME_PREVENTAUTOPLAY = 'Prevent Autoplay';
    CrowdHub_App.TAGNAME_HIDELIVESESSIONSTARTTIME = 'Hide Live Session Start Time';
    CrowdHub_App.TAGNAME_HIDELIVESESSIONTIMER = 'Hide Live Session Countdown Timer';
    CrowdHub_App.TAGNAME_RECORDEDYOUTUBE = 'Recorded YouTube';
    CrowdHub_App.TAGNAME_RECORDEDBRIGHTCOVE = 'Recorded BrightCove';
    CrowdHub_App.TAGNAME_RECORDEDVIMEO = 'Vimeo';
    CrowdHub_App.TAGNAME_RECORDEDWISTIA = 'Recorded Wistia';
    CrowdHub_App.TAGNAME_OPENTOK_CONFERENCE = 'Opentok Conference';
    CrowdHub_App.TAGNAME_HIDE_EVENT_START_TIME = 'Hide Event Start Time';
    CrowdHub_App.TAGNAME_HIDE_EVENT_END_TIME = 'Hide Event End Time';
    CrowdHub_App.TAGNAME_HIDE_EVENT_DATE = 'Hide Event Date';
    CrowdHub_App.TAGNAME_HIDE_EVENT_DATETIME = 'Hide Event Date and Time';
    CrowdHub_App.TAGNAME_LIBRARY_EXAM = 'Library Exam';
    CrowdHub_App.TAGNAME_CUSTOM_URL_STREAM = 'Custom Url Stream';
    CrowdHub_App.TAGNAME_AMAZON_IVS = 'Amazon IVS';
    CrowdHub_App.TAGNAME_CANCELED_MEETING = 'Canceled Meeting';

    CrowdHub_App.TAGNAME_LIVESESSION_GRID_LAYOUT = 'Grid Layout';
    CrowdHub_App.TAGNAME_LIVESESSION_HORIZONTAL_LAYOUT = 'Horizontal Speaker Layout';
    CrowdHub_App.TAGNAME_LIVESESSION_VERTICAL_LAYOUT = 'Vertical Speaker Layout'; // not implemented yet
    CrowdHub_App.TAGNAME_LIVESESSION_PIP_LAYOUT = 'Picture in Picture Layout'; // not implementented yet

    CrowdHub_App.TAGNAME_LIVESESSION_VIDEOCONTENTHINT_DETAIL = 'Video Content Hint - Detail';
    CrowdHub_App.TAGNAME_LIVESESSION_VIDEOCONTENTHINT_MOTION = 'Video Content Hint - Motion';
    CrowdHub_App.TAGNAME_LIVESESSION_VIDEOCONTENTHINT_TEXT = 'Video Content Hint - Text';
    CrowdHub_App.TAGNAME_LIVESESSION_SCREENSHARECONTENTHINT_DETAIL = 'Screenshare Content Hint - Detail';
    CrowdHub_App.TAGNAME_LIVESESSION_SCREENSHARECONTENTHINT_MOTION = 'Screenshare Content Hint - Motion';
    CrowdHub_App.TAGNAME_LIVESESSION_SCREENSHARECONTENTHINT_TEXT = 'Screenshare Content Hint - Text';

    //WHEN YOU ADD SOMETHING HERE, PUT IT IN entry.php TOO!

    CrowdHub_App.META_INSTAGRAM = 1;
    CrowdHub_App.META_FACEBOOK = 2;
    CrowdHub_App.META_TWITTER = 3;
    CrowdHub_App.META_WEBSITE = 4;
    CrowdHub_App.META_EMAIL = 5;
    CrowdHub_App.META_PHONE = 6;
    CrowdHub_App.META_YOUTUBE = 7;
    CrowdHub_App.META_WISTIA = 8;
    CrowdHub_App.META_NAVIGATION = 9;
    CrowdHub_App.META_OPENTOK_BROADCAST_ID = 10;
    CrowdHub_App.META_OPENTOK_ARCHIVE_ID = 11;
    CrowdHub_App.META_MAXUSERS = 12;
    CrowdHub_App.META_OPENTOK_VIDEO_URL = 13;
    CrowdHub_App.META_HTML_ATTACHMENT = 15;
    CrowdHub_App.META_CONNECTION_ID = 16;
    CrowdHub_App.META_PHONE_EXTENSION = 17;
    CrowdHub_App.META_LINK = 18;
    CrowdHub_App.META_CONTACT_US = 19;
    CrowdHub_App.META_LINKEDIN = 20;
    CrowdHub_App.META_CONTENT_AFTER = 21;
    CrowdHub_App.META_ADDRESS = 22;
    CrowdHub_App.META_VIMEO = 23;
    CrowdHub_App.META_CUSTOMSTREAMURL = 24;
    CrowdHub_App.META_PREROLLYOUTUBE = 25;
    CrowdHub_App.META_PREROLLBRIGHTCOVE = 45;
    CrowdHub_App.META_PREROLLVIMEO = 26;
    CrowdHub_App.META_PREROLLWISTIA = 27;
    CrowdHub_App.META_PREROLLMP4 = 28;
    CrowdHub_App.META_REQUIRESCOMPLETIONOF = 29;
    CrowdHub_App.META_COURSE_NAME_ALIAS = 30;
    CrowdHub_App.META_COURSE_TIMEINSECONDS = 31;
    CrowdHub_App.META_SESSIONID_SHARD = 32;
    CrowdHub_App.META_RTMP_OUT = 33;
    CrowdHub_App.META_SESSION_TAG_DISPLAY_NAME = 34;
    CrowdHub_App.META_ARCHIVING_OFF = 35;
    CrowdHub_App.META_IMAGE_ALT_TEXT = 36;
    CrowdHub_App.META_IMAGE2_ALT_TEXT = 37;
    CrowdHub_App.META_IMAGE3_ALT_TEXT = 38;
    CrowdHub_App.META_REQUIRED_CORRECT_ANSWER_PERCENTAGE = 39;
    CrowdHub_App.META_SESSION_CHAT_ID = 40;
    CrowdHub_App.META_BRIGHTCOVE_PREROLL = 45;
    CrowdHub_App.META_BRIGHTCOVE = 47;
    CrowdHub_App.META_POSTJWTURL = 48;
    CrowdHub_App.META_VIDEOJS = 49;
    CrowdHub_App.META_AMAZONIVS = 50;
    CrowdHub_App.META_UPLOAD_MP4 = 51;

    CrowdHub_App.META_DATA_MEDIA_KEYS = [
      CrowdHub_App.META_AMAZONIVS,
      CrowdHub_App.META_BRIGHTCOVE,
      CrowdHub_App.META_CUSTOMSTREAMURL,
      CrowdHub_App.META_VIDEOJS,
      CrowdHub_App.META_VIMEO,
      CrowdHub_App.META_WISTIA,
      CrowdHub_App.META_YOUTUBE,
      CrowdHub_App.META_UPLOAD_MP4,
    ];

    CrowdHub_App.META_DATA_KEYS = [
      { value: CrowdHub_App.META_INSTAGRAM, name: 'Instagram' },
      { value: CrowdHub_App.META_FACEBOOK, name: 'Facebook' },
      { value: CrowdHub_App.META_TWITTER, name: 'Twitter' },
      { value: CrowdHub_App.META_WEBSITE, name: 'Website' },
      { value: CrowdHub_App.META_EMAIL, name: 'Email' },
      { value: CrowdHub_App.META_PHONE, name: 'Phone' },
      { value: CrowdHub_App.META_YOUTUBE, name: 'Youtube' },
      { value: CrowdHub_App.META_WISTIA, name: 'Wistia' },
      { value: CrowdHub_App.META_NAVIGATION, name: 'Navigation' },
      {
        value: CrowdHub_App.META_OPENTOK_BROADCAST_ID,
        name: 'OpenTok Broadcast ID',
      },
      {
        value: CrowdHub_App.META_OPENTOK_ARCHIVE_ID,
        name: 'OpenTok Archive ID',
      },
      { value: CrowdHub_App.META_MAXUSERS, name: 'Max Users' },
      {
        value: CrowdHub_App.META_OPENTOK_VIDEO_URL,
        name: 'OpenTok Video URL',
      },
      {
        value: CrowdHub_App.META_HTML_ATTACHMENT,
        name: 'HTML Attachment',
      },
      { value: CrowdHub_App.META_CONNECTION_ID, name: 'Connection ID' },
      {
        value: CrowdHub_App.META_PHONE_EXTENSION,
        name: 'Phone Extension',
      },
      { value: CrowdHub_App.META_LINK, name: 'Link' },
      { value: CrowdHub_App.META_CONTACT_US, name: 'Contact Us' },
      { value: CrowdHub_App.META_LINKEDIN, name: 'LinkedIn' },
      { value: CrowdHub_App.META_CONTENT_AFTER, name: 'Content After' },
      { value: CrowdHub_App.META_ADDRESS, name: 'Address' },
      { value: CrowdHub_App.META_VIMEO, name: 'Vimeo' },
      {
        value: CrowdHub_App.META_PREROLLYOUTUBE,
        name: 'Preroll Youtube',
      },
      { value: CrowdHub_App.META_PREROLLVIMEO, name: 'Preroll Vimeo' },
      { value: CrowdHub_App.META_PREROLLWISTIA, name: 'Preroll Wistia' },
      { value: CrowdHub_App.META_PREROLLMP4, name: 'Preroll MP4' },
      {
        value: CrowdHub_App.META_REQUIRESCOMPLETIONOF,
        name: 'Requires Completion Of',
      },
      { value: CrowdHub_App.META_RTMP_OUT, name: 'RTMP Out' },
      {
        value: CrowdHub_App.META_REQUIRED_CORRECT_ANSWER_PERCENTAGE,
        name: 'Required Correct Answer Percentage',
      },
      {
        value: CrowdHub_App.META_PREROLLBRIGHTCOVE,
        name: 'Preroll BrightCove',
      },
      { value: CrowdHub_App.META_BRIGHTCOVE, name: 'Brightcove' },
      { value: CrowdHub_App.META_AMAZONIVS, name: 'Amazon IVS' },
      {
        value: CrowdHub_App.META_SESSION_TAG_DISPLAY_NAME,
        name: 'Session Tag Display Name',
      },
      { value: CrowdHub_App.META_UPLOAD_MP4, name: 'Video Upload MP4' },
    ];

    CrowdHub_App.CONFIG.PARTNER_METADATA_IDS = [
      { value: 0, name: 'Type' },
      CrowdHub_App.META_DATA_KEYS[0],
      CrowdHub_App.META_DATA_KEYS[1],
      CrowdHub_App.META_DATA_KEYS[2],
      CrowdHub_App.META_DATA_KEYS[3],
      CrowdHub_App.META_DATA_KEYS[4],
      CrowdHub_App.META_DATA_KEYS[5],
      CrowdHub_App.META_DATA_KEYS[6],
      CrowdHub_App.META_DATA_KEYS[20],
      CrowdHub_App.META_DATA_KEYS[33],
    ];

    CrowdHub_App.DIMENSION_INSTAGRAM = 1;
    CrowdHub_App.DIMENSION_FACEBOOK = 2;
    CrowdHub_App.DIMENSION_TWITTER = 3;
    CrowdHub_App.DIMENSION_WEBSITE = 4;
    CrowdHub_App.DIMENSION_PHONE = 5;
    CrowdHub_App.DIMENSION_BLACKOUTSTART = 6;
    CrowdHub_App.DIMENSION_BLACKOUTEND = 7;
    CrowdHub_App.DIMENSION_LINKEDIN = 20; // out of order to match the meta value
    CrowdHub_App.DIMENSION_DOB = 9;
    CrowdHub_App.DIMENSION_ADDRESS = 10;

    CrowdHub_App.NOTIFICATION_TYPE_FORUM_TAG = 1;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_TAG = 2;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_LIKE = 3;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_LIKE = 4;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT_LIKE = 5;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT_LIKE = 6;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT = 7;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT = 8;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_REPLY = 9;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_REPLY = 10;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT_REPLY = 11;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT_REPLY = 12;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_POST = 13;
    CrowdHub_App.NOTIFICATION_TYPE_FEED_NEW_POST = 14;
    CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_TOPIC = 15;
    CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_ENROLLED = 16;
    CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_WAITLISTED = 17;
    CrowdHub_App.NOTIFICATION_TYPE_EXTERNAL_URL = 18;
    CrowdHub_App.NOTIFICATION_TYPE_TARGETED = 19;

    CrowdHub_App.NOTIFICATION_PREF_TYPE_DM_REQUEST = 1; //New dm message requests
    CrowdHub_App.NOTIFICATION_PREF_TYPE_DM = 2; // New dm messages

    CrowdHub_App.NOTIFICATION_PREF_TYPE_FORUM_TOPIC = 3; //New forum topics
    CrowdHub_App.NOTIFICATION_PREF_TYPE_FORUM_ACTIVITY = 4; //Forum activity (new forum post on forum you follow)
    CrowdHub_App.NOTIFICATION_PREF_TYPE_FEED_ACTIVITY = 5; //Social feed activity (new feed post on global/cohort)
    CrowdHub_App.NOTIFICATION_PREF_TYPE_TAGGED = 6; //Tagged on a post
    CrowdHub_App.NOTIFICATION_PREF_TYPE_RESPONSES = 7; //Responses on your posts and comments
    CrowdHub_App.NOTIFICATION_PREF_TYPE_LIKES = 8; //Likes on posts and comments
  }
}
